import {WOW} from "wowjs";

require("jquery-ui/ui/core");
require("jquery-ui/ui/effect");
require("jquery-ui/ui/widgets/datepicker");

/* eslint-disable-next-line */
(function ($, ajax_localize) {

    $(document).ready(function () {

        const wow = new WOW();

        wow.init();

        let headerScrollTopOffset = 0;

        if ($("body").hasClass("admin-bar") && ($(window).width() > 600)) {
            headerScrollTopOffset = $("html").css("margin-top");
        }

        // Watch for when header is scrolled to or away from the top of the viewport
        // If header is scrolled to the top of the page, we know it's been stickied based on it having position: sticky
        // Add class when it's sitting at the top of the page, remove it when it's been scrolled away
        $(".site-header-wrap").observeScrollTopChanges(headerScrollTopOffset).on("scroll-top-change", (evt) => {

            $(evt.target).toggleClass("sticky", evt.detail.scrolledToTop);

        });

        // Top level dropdown toggles
        //$(".header-navbar .navbar-nav").find(".menu-item-has-children").children(".dropdown-toggle").attr("data-toggle", "dropdown").attr("role","button");

        // Second level dropdown toggles
        $(".header-navbar .navbar-nav").find(".dropdown > .dropdown-menu > .dropdown").attr("data-toggle", "");
        /*$(".header-navbar .navbar-nav").find(".dropdown > .dropdown-menu > .dropdown").each(function () {

            let dropdownMenu = $(this).find(".dropdown-menu");

            // Briefly show parent dropdown so sub menu is visible
            $(this).closest(".dropdown-menu").css("display", "block");

            dropdownMenu.css({
                "display": "block",
                "position": "absolute",
                "left": "-100%",
                "max-height": "initial",
                "height": "auto",
            });

            var subMenuHeight = dropdownMenu.outerHeight();

            // Hide parent dropdown
            $(this).closest(".dropdown-menu").css("display", "");

            dropdownMenu
                .data("full-height", subMenuHeight)
                .css({
                    "display": "",
                    "position": "",
                    "left": "",
                    "max-height": "",
                    "height": "",
                });

            $(this).on("show.bs.dropdown", function () {
                dropdownMenu.css("height", dropdownMenu.data("full-height"));
            });

            $(this).on("hide.bs.dropdown", function () {
                dropdownMenu.css("height", "0");
            });

        });*/

        /*
            Mobile menu dropdown
         */

        if($(window).width() < 992){
            $('.navbar-collapse').find('.dropdown.menu-item-has-children').children('.nav-link').click(function (e) {
                e.preventDefault();
                console.log('clicked');
                $(this).siblings().toggleClass('menu-expanded');


                $('.close-list-item').click(function(){
                    $(this).parent().removeClass('menu-expanded');
                })
            });
        }


        if($(window).width() < 992){
            $('.dropdown-toggle').attr('data-toggle','');
            $(".dropdown-menu").append('<li class="close-list-item">Back</li>');

            $('.dropdown-menu').each(function(){
                var title = $(this).siblings().text();
                var href = $(this).siblings().attr('href');

                $(this).prepend('<li class="list-heading"><a href="'+href+'">'+title+'</a></li>');
            });
        }

        $('.navbar-collapse')
            .on('hide.bs.collapse', function() {
                $('body').removeClass('no-scroll');
            })
            .on('show.bs.collapse', function(evt) {

                $('body').addClass('no-scroll');

                // Get position and size of header navbar element so we can calculate top position of mobile men
                const headerBoundingRect = $(".site-header-wrap").get(0).getBoundingClientRect();

                // Position top of mobile menu directly below header navbar
                $(evt.target).css("top", headerBoundingRect.bottom);

            });


        // // fbx-modal
        // // identify an element to observe
        // const elementToObserve = document.querySelector(".fbx-modal");
        //
        // // create a new instance of `MutationObserver` named `observer`,
        // // passing it a callback function
        // const observer = new MutationObserver(function() {
        //     console.log('callback that runs when observer is triggered');
        // });
        // observer.observe(elementToObserve);
        // // call `observe()` on that MutationObserver instance,
        // // passing it the element to observe, and the options object
        // //observer.observe(elementToObserve, {subtree: true, childList: true});


        $(".header-navbar .btn-search").on("click", function () {

            $("#header-search-overlay")
                .addClass("fade show")
                .find(".search-input")
                    .focus();

            let headerPositionData = $(".site-header-wrap").get(0).getBoundingClientRect();

            $("<div>")
                .addClass("modal-backdrop header-search-overlay-backdrop")
                .css("opacity", 0) // Temporary
                .css("top", (headerPositionData.y + $("#header-search-overlay").outerHeight()))
                .appendTo($("body")).fadeTo(150, 0.2);

            $("body").addClass("modal-open");

        });

        $("#js-header-search-overlay-close").on("click", function () {

            $("#header-search-overlay")
                .removeClass("fade show")
                .find(".search-input")
                    .blur();

            $(".header-search-overlay-backdrop").fadeOut(200, "linear", function () {
                $(this).remove();
            });

            $("body").removeClass("modal-open");

        });

        $(window).on("load resize orientationchange", normalizeOrangeCarouselHeights);


        // Datepicker form field initialization
        $(".date-picker-input").datepicker({
            dateFormat: "dd / mm / yy",
            changeMonth: true,
            changeYear: true,
        });

        $(".custom-file-input").on("change", function(evt){

            const selectedFiles = $(evt.target).get(0).files;

            // Update text of the span element in neighbouring label element to the selected file name
            $(evt.target).siblings(".custom-file-label").children("span").text(selectedFiles[0].name);

        });

        $(".form-tooltip").tooltip({html: true});

        /**
         * Alerts - Update "See Details" text on open/close
         */
        $('.alert .btn-close').on('click load', function () {
            $('body.tfi-site-ics .site-header-wrap').addClass('alert-closed');
        });

        /**
         * Alert Banner Slider - Add .active to first slide
         */
        $('#alert-slider .carousel-inner .carousel-item:first-of-type').addClass('active');

        /**
         * Alerts - scroll to alert when clicked in the banner
         */
        $.each($('#alert-accordion .accordion-item-card'), function () {
            var id = $(this).find('.card-header').attr('id');
            var show = ($(this).find('.card-header .alert-header-trigger-btn .btn-accordion-trigger').attr('aria-expanded') === 'true');

            if (show) {
                $("html, body").animate({
                    scrollTop: $('#' + id).offset().top - 200,
                }, 400);
            }
        });

        /**
         * Back to top button - fade in and scroll functionality
         */
        $(window).scroll(function () {
            if ($(window).scrollTop() > 300) {
                $('#back-to-top').fadeIn().addClass('show');
            } else {
                $('#back-to-top').fadeOut().removeClass('show');
            }
        });
        $('#back-to-top').click(function () {
            $("html, body").animate({
                scrollTop: 0,
            }, 400);
        });

        /*
            Columns
         */
        $('.wp-block-columns').each(function () {
            if (!$(this).hasClass('container')) {
                $(this).addClass('container');
            }
        });

        // FAQs page "Load More" buttons
        /* eslint-disable-next-line */
        if( ajax_localize.hasOwnProperty('ajax_url')){
            $(".page-faqs .btn-load-more").each(function () {

                var listItemHolder = $(this).siblings(".faq-accordion");

                // Hide the button if there aren't any more posts to load
                if ($(".list-items-loader", listItemHolder).length < 1) {
                    $(this).hide();
                }

                $(this).on("click", function (evt) {

                    evt.preventDefault();

                    var loadMoreBtn = $(this);
                    var listItemLoader = $(".list-items-loader", listItemHolder);

                    // Save the button's text so we can restore it when removing the loading state
                    var origButtonText = loadMoreBtn.html();

                    if (loadMoreBtn.is(".loading")) {
                        return false;
                    }

                    loadMoreBtn
                        .attr("disabled", true)
                        .addClass("loading")
                        .text("Loading...");

                    var action = "get_faqs";

                    // Check if the list item loader has a custom action set
                    if ((listItemLoader.data("action") !== undefined) && (listItemLoader.data("action") !== "")) {
                        action = listItemLoader.data("action");
                    }

                    $.post(
                        ajax_localize.ajax_url,
                        {
                            "action": action,
                            "data": $.param(listItemLoader.data()),
                        },
                        function (data) {

                            // Remove the existing list item loader since a new one will be included in the response
                            listItemLoader.remove();

                            // If new faq items were returned
                            if (data) {

                                loadMoreBtn
                                    .attr("disabled", false)
                                    .removeClass("loading")
                                    .html(origButtonText);

                                var newFAQItems = $($.parseHTML(data));

                                newFAQItems.filter(":not(.list-items-loader)").addClass("fade");

                                listItemHolder.append(newFAQItems);

                                // Wait a split second before adding class to fade in new faqs
                                setTimeout(function () {
                                    newFAQItems.addClass("show");
                                }, 100);

                                // Look for the new list item loader tag
                                // If it's not there, there aren't any more posts to show so hide the load more button
                                if ($(".list-items-loader", listItemHolder).length < 1) {
                                    loadMoreBtn.remove();
                                }

                            } else {

                                loadMoreBtn.fadeOut(400, function () {
                                    $(this).remove();
                                });

                                $(".no-more-results-msg").show();

                            }

                        }
                    );

                });

            });
        }




        // Search tabs dropdown on mobile
        $("#search-category-dropdown-menu").on("change", function(){

            $("#search-page-filter-tabs").find(".nav-link.active").removeClass("active");
            $("#search-page-filter-tab-content").find(".tab-pane.active").removeClass("active");

            $("#search-page-filter-tabs").find(".nav-link[href='" + $(this).val() + "']").addClass("active");
            $($(this).val()).addClass("show active");

        });

        // FAQ Categories on mobile
        $("#faq-categories-dropdown").on("change", function(){

            if($(this).val()){
                window.location.href = $(this).val();
            }

            return false;

        });

        /**
         * Add site class to body to test different sites
         */
        // $('body').removeClass('tfi-site-canpar').addClass('tfi-site-ics');      // ICS
        // $('body').removeClass('tfi-site-canpar').addClass('tfi-site-loomis');   // Loomis
        // $('body').removeClass('tfi-site-canpar').addClass('tfi-site-tforce');   // TForce


        //TODO move this slick js logic to their JS files within blocks
        $('.slick-content').slick({
            infinite: true,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 3,
            variableWidth: true,
            accessibility: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ],
        });

        $('.slick-post-content').slick({
            infinite: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: true,
            accessibility: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ],
        });


        $('.video-modal').on('hidden.bs.modal', function () {
            $(".video-modal iframe").attr("src", $(".video-modal iframe").attr("src"));
            $('.embedded-video').trigger('pause');

            console.log('hidden');
        });


        // Update "Register" button in "My Portal" CTA to open register modal
        $(".cta-block:last-child .learn-more-link.two-links[href='#registration-modal']").each(function(){

            $(this).attr("data-toggle", "modal").attr("data-target", $(this).attr("href"));

        });

    });

    $.fn.observeScrollTopChanges = function (offset = 0) {

        // Top and bottom margin values position marker element at the top of the box area of the current element, regardless of it's top margin
        // Need to increase bottom margin's negative value by 1px to compensate for marker's height
        // Essentially makes the marker invisible
        const marker = $("<div>").css({
            "margin-top": this.css("marginTop"),
            "margin-bottom": ((parseInt(this.css("marginTop")) + 1) * -1),
            "height": "1px",
        });

        if (parseInt(offset) > 0) {
            marker.css({
                "position": "relative",
                "top": ((parseInt(offset) + 1) * -1),
            });
        }

        // Add to DOM before element being observed
        // When marker is hidden beyond the top of the viewport, the target element will be touching the top of the viewport
        this.before(marker);

        // Create observer object
        const scrollTopObserver = new IntersectionObserver((entries) => {

            // Width, height and scroll position of element being observed
            const targetBoundingRect = entries[0].boundingClientRect;
            // Width height and position of viewport
            const viewportBoundingRect = entries[0].rootBounds;

            // The element that should have the event triggered on it
            // Basically, the element that we want to know when it has reached the top of the page on scroll
            const evtTrigger = entries[0].target.nextSibling;

            let scrolledToTop = false;

            // If the entire marker element has scrolled beyond the top of the viewport
            if (targetBoundingRect.bottom < viewportBoundingRect.top) {

                scrolledToTop = true;

                // If the entire marker element is visible again
            } else if (targetBoundingRect.bottom >= viewportBoundingRect.top) {

                scrolledToTop = false;

            }

            // Create custom event and pass information about whether the element was just hit the top of the page or if it is being scrolled away
            const evt = new CustomEvent("scroll-top-change", {detail: {scrolledToTop: scrolledToTop}});

            evtTrigger.dispatchEvent(evt);

            // Threshold says how much of the element needs to be visible before checking for intersection
            // 0 means as soon as any part of the element is visible
        }, {threshold: [0]});

        // Start observing the marker element
        scrollTopObserver.observe(marker.get(0));

        // Return current element to allow for jQuery function chaining
        return this;

    };

    function normalizeOrangeCarouselHeights() {

        $(".orange-block.carousel-block").each(function () {

            var windowScreenSize = $( document ).width();

            var origStyleAttr = "";

            const carouselItems = $(".carousel-item", this);
            const carouselItemCaptions = $(".carousel-item .carousel-caption", this);

            // Ensure caption isn't stretched so we can get actual height, especially on smaller screens
            if (windowScreenSize <= 991) {
                origStyleAttr = carouselItems.attr("style");
                carouselItems.attr("style", "min-height: 0 !important");
            }

            carouselItems.css("align-items", "flex-start");

            // Run through each item in jQuery set and get height and then pull basic array out result
            const carouselItemMinHeightsArr = carouselItemCaptions.map(function () {
                return $(this).outerHeight() + parseInt($(this).parent().css("padding-top")) + parseInt($(this).parent().css("padding-bottom"));
            }).get();

            // Restore original styles
            if (windowScreenSize <= 991) {
                carouselItems.attr("style", origStyleAttr);
            }

            carouselItems.css("align-items", "");

            var maxSlideHeight = Math.max.apply(null, carouselItemMinHeightsArr);

            if (windowScreenSize <= 991) {

                var imageHeight = $('.carousel-item .carousel-image').outerHeight();

                if ($('body').hasClass('tfi-site-ics')) {
                    maxSlideHeight = imageHeight + maxSlideHeight + 30;
                } else {
                    maxSlideHeight = imageHeight + maxSlideHeight + 50;
                }

            }

            // If the max slide height is less than the current height of the block, we don't need to update the min-height
            if(maxSlideHeight <= $(this).outerHeight()){
                return false;
            }


            // Set the min-height of all .carousel-item
            if($('body').hasClass('tfi-site-tforce')) {
                carouselItems.css("min-height", maxSlideHeight + 72);
            } else {
                carouselItems.attr('style', 'min-height: '+maxSlideHeight+'px !important');
            }

        });

    }

    // For testimonials
    //Normalize the internal carousel height
    function normalizeTestimonialCarouselHeights() {

        $('.testimonial-large-block').each(function () {
            var items = $('.carousel-item .card .main', this);
            // reset the height
            items.css('min-height', 0);
            // set the height
            var maxHeight = Math.max.apply(null,
                items.map(function () {
                    return $(this).outerHeight()
                }).get());
            //Will fix the min-height of all .carousel-item
            items.css('min-height', maxHeight + 120 + 'px');
            $('.carousel-container').css('min-height', maxHeight + 120 + 'px');
            //To fix the height of the d-flex div to fix the content on the middle of that div
            //dflex.css('height', maxHeight + 'px');
        })

        $('.tfi-site-ics .testimonial-large-block').each(function () {
            var items = $('.carousel-item .card .main', this);
            // reset the height
            items.css('min-height', 0);
            // set the height
            var maxHeight = Math.max.apply(null,
                items.map(function () {
                    return $(this).outerHeight()
                }).get());
            //Will fix the min-height of all .carousel-item
            items.css('min-height', maxHeight + 100 + 'px');
            $('.carousel-container').css('min-height', maxHeight + 100 + 'px');
            //To fix the height of the d-flex div to fix the content on the middle of that div
            //dflex.css('height', maxHeight + 'px');
        })

    }

    $(window).on(
        'load resize orientationchange',
        normalizeTestimonialCarouselHeights);


    // This script will read the current url, if we have a FAQ condition, will open that accordion and scroll to that item
    if($('body').hasClass('page-faqs')){
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams) {
            var faqh = urlParams.get('faqh');
            $(".collapse[data-id='" + faqh + "']").collapse('toggle');
            Element.prototype.documentOffsetTop = function () {
                return this.offsetTop + (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0);
            };
            //Not working and doesnt seem to be required
            // var top = document.querySelector("[data-id='" + faqh + "']").documentOffsetTop() - (window.innerHeight / 2);
            // window.scrollTo(0, top);
        }
    }


    // To open submenus on focus
    $('.dropdown.menu-item-has-children .nav-link').focus( function() {
        $(this).parent().addClass('open');
    });


    $('.dropdown.menu-item-has-children .nav-link').blur( function() {
        //$(this).parent().removeClass('open');
        // $(this).attr('aria-expanded',false);
        // console.log ('saiu da sessao')
    });

    $('.dropdown.menu-item-has-children .nav-link').click(function () { 
        $('.open').removeClass('open');
        $(this).addClass('open');
    });
      


    /* eslint-disable-next-line */
})(jQuery, ajax_localize);